<template>
  <details class="example-box mt-3" style="margin-top: 0.5rem; font-size: 13px;" :open="isOpen" @toggle="onToggle">
    <summary><strong>Ver ejemplo visual de la tabla esperada</strong></summary>
    <small class="text-muted d-block mt-2 mb-2">Esta tabla es solo una referencia visual y no es editable.</small>
    <div class="table-responsive mt-2">
      <table class="table table-sm table-bordered mb-0" style="font-size: 12px;">
        <thead>
          <tr>
            <th v-for="col in columns" :key="col">{{ col }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="(col, index) in columns" :key="col + index">{{ sample[index] || '' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </details>
</template>

<script>
export default {
  name: 'ImportExampleTable',
  props: {
    importType: {
      type: String,
      default: 'initial_load'
    },
    openToken: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isOpen: true
    }
  },
  watch: {
    openToken() {
      this.isOpen = true
    }
  },
  computed: {
    columns() {
      if (this.importType === 'initial_load') {
        return ['Nombre', 'Apellidos', 'Apodo', 'Whatsapp', 'Invitados']
      }

      return ['N°', 'Nombre', 'Apellidos', 'Apodo', 'Whatsapp', 'Email', 'Invitados', 'Mesa', 'Restriccion', 'Comentarios', 'Confirmacion', 'Fecha Confirmacion', 'Metodo Confirmacion', 'Ultimo Mensaje']
    },
    sample() {
      if (this.importType === 'initial_load') {
        return ['Juan', 'Perez', 'Juanito', '97115892152', '2']
      }

      return ['1', 'Juan', 'Perez', 'Juanito', '97115892152', 'juan@example.com', '2', 'Mesa 3', 'No', 'Actualizacion de mesa', 'Si', '2026-07-20', 'admin', '']
    }
  },
  methods: {
    onToggle(event) {
      this.isOpen = !!(event && event.target && event.target.open)
    }
  }
}
</script>

<style scoped>
.example-box {
  border: 0;
  border-radius: 0;
  padding: 0;
  background: transparent;
}
</style>
